import React from 'react';

import { FileText, HandClick, Receipt, Video, Lock,} from 'tabler-icons-react';
import '../pages/KanbanColumn.css';

/* ───────────────────────────────
   TIPOS DE DADOS & CONSTANTES
──────────────────────────────── */

export type InstallmentEntry = {
  data: Date | null;
  client_id?: string;
  amount?: number;
};

export type Product = {
  productId: string;
  productName: string;
  quantity: number;
  currency: string;
  price: number;
  discount: number;
  salesPackageId?: string;
  salesPackageName?: string;
  discountType?: 'percent' | 'fixed';
  discountValue?: number;
  payment?: {
    tipo: 'avista' | 'parcelado';
    data?: Date | null;
    client_id?: string;
    parcelas?: InstallmentEntry[];
  };
  sold?: boolean;
};

export type Stage = {
  id: string;
  opportunity_id: string;
  name: string;
  created_at: string; // formato YYYY-MM-DD
  finished_at?: string;
};

export type OpportunityFile = {
  id: string;
  opportunity_id: string;
  file_name: string;
  file: string | File;
  created_at: string; // formato YYYY-MM-DD
  size: number;
};

export type Opportunity = {
  id: string;
  client: string;
  client_ids: string[];
  contact_id: string;
  campaign_id?: string;
  user_id: string;
  owner?: string | null;
  name: string;
  value: number;
  probability: number;
  discount: number;
  decision_maker: string;
  influencer: string;
  investidor: string;
  products: Product[];
  stages: Stage[];
  files: OpportunityFile[]
  startDate: string;
  client_image?: string;
  noSalesMade?: boolean; // Indica se a oportunidade foi perdida ou não
  remito: string;
  deletedAt?: string | null;
};

export type OpportunityForm = Omit<Opportunity, 'id'>;

export const initialOpportunityForm: OpportunityForm = {
  user_id: 'user1',
  owner: null,
  name: '',
  client: '',
  client_ids: [],
  contact_id: '',
  campaign_id: '',
  value: 0,
  probability: 0,
  discount: 0,
  decision_maker: '',
  influencer: '',
  investidor: '',
  products: [],
  files: [],
  stages: [
    {
      id: 's1',
      opportunity_id: '1',
      name: 'Value Proposition',
      created_at: '2025-01-01'
    }
  ],
  startDate: new Date().toISOString(),
  client_image: '',
  remito: ''
};

export const currencyOptions = [
  { value: 'USD', label: 'USD' },
  { value: 'ARS', label: 'ARS' },
];

export const STAGES = [
  'Value Proposition',
  'Quotation',
  'Demonstration',
  'Negociation',
  'Closed'
];

export const stageColors: Record<string, string> = {
  'Value Proposition': '#D3E4CD',
  'Negociation': '#E2A1A1',
  'Quotation': '#F6D8AE',
  'Demonstration': '#F4B393',
  'Closed': '#A1D2CE'
};

export const stageIcons: Record<string, React.ReactNode> = {
  'Value Proposition': <FileText size={18} />,
  'Negociation': <HandClick size={18} />,
  'Quotation': <Receipt size={18} />,
  'Demonstration': <Video size={18} />,
  'Closed': <Lock size={18} />
};

export const TABLE_MAX_HEIGHT = '780px';